export default __webpack_public_path__ + "static/media/menu2_hl.29592db2.png";